/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Accent_HintInputs */

const cs_settings_office_accent_hint = /** @type {(inputs: Settings_Office_Accent_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hlavní barva přihlášení a menu pro vaši kancelář. Prázdné = výchozí barva produktu.`)
};

const en_settings_office_accent_hint = /** @type {(inputs: Settings_Office_Accent_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary colour for login and menu for your office. Empty = product default.`)
};

/**
* | output |
* | --- |
* | "Primary colour for login and menu for your office. Empty = product default." |
*
* @param {Settings_Office_Accent_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_accent_hint = /** @type {((inputs?: Settings_Office_Accent_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Accent_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_accent_hint(inputs)
	return cs_settings_office_accent_hint(inputs)
});